"use client"

import { useState, useEffect } from "react"
import MainLayout from "../components/layout/MainLayout"
import DashboardStats from "../components/dashboard/DashboardStats"
import QuickActions from "../components/dashboard/QuickActions"
import RecentProjects from "../components/dashboard/RecentProjects"

export default function NewAdminDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768)
      if (window.innerWidth < 768) {
        setSidebarOpen(false)
      } else {
        setSidebarOpen(true)
      }
    }

    checkScreenSize()
    window.addEventListener("resize", checkScreenSize)

    return () => {
      window.removeEventListener("resize", checkScreenSize)
    }
  }, [])

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <MainLayout title="Dashboard">
      <div className="space-y-8">
        <DashboardStats />
        <QuickActions />
        <RecentProjects />
      </div>
    </MainLayout>
  )
}

